import { useQuery } from "react-query";
import { getJSON } from "../api/http";
import { endpoints } from "../api/endpoints";

const getContractsList = async () => getJSON(endpoints.contracts.list);

export const useContractsList = () => {
  const { data, isLoading, error } = useQuery(
    "contractsList",
    getContractsList,
    {
      staleTime: Infinity,
    }
  );

  return {
    isLoading,
    data: data?.data,
    error,
  };
};
